import { abrePDF } from "../../../utils/pdf";
import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Badge,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

function EstadoCuenta() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;
  const URL_DEPARTAMENTOS_CLIENTES =
    process.env.REACT_APP_URL_DEPARTAMENTOS_CLIENTES;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_ESTADO_CUENTA = process.env.REACT_APP_URL_ESTADO_CUENTA;
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [clientes, setClientes] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");
  const [departamentos, setDepartamentos] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState([]);
  const [filtroLiquidado, setFiltroLiquidado] = useState("");
  const [mailTo, setMailTo] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [areas, setAreas] = useState("");
  const [nombreCliente, setNombreCliente] = useState([]);
  const [saldo, setSaldo] = useState(0);
  const [nombreComercialCliente, setNombreComercialCliente] = useState([]);
  const [claveCliente, setClaveCliente] = useState([]);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [modalMail2, setModalMail2] = useState(false);
  const toggleMail2 = () => setModalMail2(!modalMail2);
  const [modalMail3, setModalMail3] = useState(false);
  const toggleMail3 = () => setModalMail3(!modalMail3);

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [modalAgrupado, setModalAgrupado] = useState(false);
  const toggleAgrupado = () => setModalAgrupado(!modalAgrupado);

  const [modalGlobal, setModalGlobal] = useState(false);
  const toggleGlobal = () => setModalGlobal(!modalGlobal);

  // C12: Modal EstadoCuenta por Surtido
  const [modalPorSurtido, setModalPorSurtido] = useState(false);
  const togglePorSurtido = () => setModalPorSurtido(!modalPorSurtido);
  const [gruposPorSurtido, setGruposPorSurtido] = useState([]);
  const [anticiposPorSurtido, setAnticiposPorSurtido] = useState([]);

  const [activo, setActivo] = useState("Si");
  const [vendedor, setVendedor] = useState("");
  const [grupo, setGrupo] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState("");
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [movimientos, setMovimientos] = useState([]);
  const [idCliente, setIdCliente] = useState("");

  // D8: abonar y aplicar anticipos desde el estado de cuenta del cliente
  const URL_ABONOS = process.env.REACT_APP_URL_ABONOS;
  const URL_ANTICIPOS = process.env.REACT_APP_URL_ANTICIPOS;
  const URL_BANCOS_CTE = process.env.REACT_APP_URL_BANCOS;
  const URL_SURTIDOS_CTE = process.env.REACT_APP_URL_SURTIDOS;

  const [bancosCte, setBancosCte] = useState([]);
  const [anticiposCte, setAnticiposCte] = useState([]);
  const [vendedorCliente, setVendedorCliente] = useState("");

  const [modalAbonoCte, setModalAbonoCte] = useState(false);
  const [surtidoSel, setSurtidoSel] = useState(null);
  const [abFecha, setAbFecha] = useState(moment().format("YYYY-MM-DD"));
  const [abImporte, setAbImporte] = useState(0);
  const [abBanco, setAbBanco] = useState("");
  const [abFormaPago, setAbFormaPago] = useState("Transferencia");
  const [abObs, setAbObs] = useState("NA");

  const [modalAplicarCte, setModalAplicarCte] = useState(false);
  const [anticipoCteSel, setAnticipoCteSel] = useState("");
  const [aplicarImpCte, setAplicarImpCte] = useState(0);

  const [guardandoCte, setGuardandoCte] = useState(false);

  // Bancos para el abono (mismo criterio que AbonosCreate: solo Taref)
  useEffect(() => {
    if (!URL_BANCOS_CTE) return;
    axios
      .get(URL_BANCOS_CTE, { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } })
      .then((res) => setBancosCte((res.data || []).filter((b) => b.tipo !== "Kasher")))
      .catch((err) => console.log(err));
  }, [URL_BANCOS_CTE]);

  async function cargarAnticiposCliente(idCte) {
    try {
      const res = await axios.get(URL_ANTICIPOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      });
      const conSaldo = (res.data || []).filter(
        (a) =>
          (a.tipo || "Cliente") === "Cliente" &&
          a.is_active === "Si" &&
          Number(a.saldo) > 0.01 &&
          String(a.clientes?.[0]?._id || a.clientes?.[0]) === String(idCte)
      );
      setAnticiposCte(conSaldo);
    } catch (err) {
      console.log("[anticipos cliente]", err);
      setAnticiposCte([]);
    }
  }

  function abrirAbonoSurtido(s) {
    setSurtidoSel(s);
    setAbFecha(moment().format("YYYY-MM-DD"));
    setAbImporte(Number(s.saldo) || 0); // default: liquidar la nota
    setAbBanco("");
    setAbFormaPago("Transferencia");
    setAbObs("NA");
    setModalAbonoCte(true);
  }

  async function abrirAplicarAnticipoCte(s) {
    setSurtidoSel(s);
    setAnticipoCteSel("");
    setAplicarImpCte(0);
    await cargarAnticiposCliente(idCliente);
    setModalAplicarCte(true);
  }

  // Abono normal: el back sube abonos y baja saldo del CLIENTE (pool T);
  // el saldo del surtido se ajusta aquí, igual que hace AbonosCreate.
  async function guardarAbonoCte() {
    const imp = parseFloat(abImporte) || 0;
    if (imp <= 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Captura un importe mayor a 0" });
      return;
    }
    if (imp > Number(surtidoSel?.saldo || 0) + 0.01) {
      Swal.fire({ icon: "error", title: "Oops...", text: "El importe excede el saldo de la nota" });
      return;
    }
    if (!abBanco) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Selecciona el banco" });
      return;
    }
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      setGuardandoCte(true);
      await axios.post(
        URL_ABONOS,
        {
          fecha: abFecha,
          importe: imp,
          clientes: idCliente,
          colaboradores: vendedorCliente || undefined,
          surtidos: surtidoSel?._id,
          formaPago: abFormaPago,
          bancos: abBanco,
          comisionPagada: "No",
          observaciones: abObs || "NA",
          concepto: "Abono",
          codigoAgrupado: uuidv4(),
        },
        { headers }
      );
      // Bajar el saldo del surtido
      await axios.patch(
        `${URL_SURTIDOS_CTE}/${surtidoSel._id}`,
        { saldo: Number((Number(surtidoSel.saldo) - imp).toFixed(2)) },
        { headers }
      );
      setModalAbonoCte(false);
      Swal.fire({ icon: "success", title: "Abono registrado", timer: 1400, showConfirmButton: false });
      setTimeout(() => window.location.reload(), 1100);
    } catch (err) {
      console.log("[abono cliente]", err);
      Swal.fire({
        icon: "error",
        title: "No se pudo registrar",
        text: err?.response?.data?.message || "Revisa los datos",
      });
    } finally {
      setGuardandoCte(false);
    }
  }

  // Aplicar anticipo: NO mueve el saldo del cliente (el dinero ya entró al
  // crear el anticipo). Solo baja el saldo del surtido y el del anticipo.
  async function guardarAplicarAnticipoCte() {
    const imp = parseFloat(aplicarImpCte) || 0;
    const ant = anticiposCte.find((a) => a._id === anticipoCteSel);
    if (!ant) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Selecciona el anticipo" });
      return;
    }
    if (imp <= 0) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Captura un importe mayor a 0" });
      return;
    }
    if (imp > Number(ant.saldo) + 0.01) {
      Swal.fire({ icon: "error", title: "Oops...", text: "El importe excede el saldo del anticipo" });
      return;
    }
    if (imp > Number(surtidoSel?.saldo || 0) + 0.01) {
      Swal.fire({ icon: "error", title: "Oops...", text: "El importe excede el saldo de la nota" });
      return;
    }
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      setGuardandoCte(true);
      await axios.post(
        `${URL_ABONOS}AplicarAnticipo`,
        {
          fecha: moment().format("YYYY-MM-DD"),
          importe: imp,
          clientes: idCliente,
          colaboradores: vendedorCliente || undefined,
          surtidos: surtidoSel?._id,
          formaPago: `Anticipo ${ant.idAnticipo} Aplicado`,
          concepto: `Anticipo ${ant.idAnticipo} Aplicado`,
          bancos: ant.bancos?.[0]?._id || ant.bancos?.[0],
          comisionPagada: "No",
          observaciones: `Aplicado desde Estado de Cuenta a Nota ${surtidoSel?.idSurtido}`,
          codigoAgrupado: uuidv4(),
          anticipos: ant._id,
        },
        { headers }
      );
      // Baja el saldo del surtido
      await axios.patch(
        `${URL_SURTIDOS_CTE}/${surtidoSel._id}`,
        { saldo: Number((Number(surtidoSel.saldo) - imp).toFixed(2)) },
        { headers }
      );
      // Baja el saldo del anticipo y sube lo utilizado.
      // OJO: el endpoint hace $inc { utilizado: +x, saldo: -x }, así que
      // recibe el MONTO APLICADO, no los valores finales.
      await axios.patch(
        `${URL_ANTICIPOS}AplicarAbono/${ant._id}`,
        { saldo: imp, utilizado: imp },
        { headers }
      );
      setModalAplicarCte(false);
      Swal.fire({ icon: "success", title: "Anticipo aplicado", timer: 1400, showConfirmButton: false });
      setTimeout(() => window.location.reload(), 1100);
    } catch (err) {
      console.log("[aplicar anticipo cliente]", err);
      Swal.fire({
        icon: "error",
        title: "No se pudo aplicar",
        text: err?.response?.data?.message || "Revisa los datos",
      });
    } finally {
      setGuardandoCte(false);
    }
  }
  const [saldoInicial, setSaldoInicial] = useState(0);
  const [plazo, setPlazo] = useState(0);

  const [totalTotalCargos, setTotalTotalCargos] = useState(0);
  const [totalTotalAbonos, setTotalTotalAbonos] = useState(0);
  const [totalTotalSaldo, setTotalTotalSaldo] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
    .get(`${URL_CLIENTES}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;

        if (user.vendedor === "Si") {
          allClientes = allClientes.filter(cliente => cliente.vendedor[0].email === user.email);
        }

        // Array para pagination
        let arrayTabla = allClientes
          .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
          .map((a) => {
            // if (user.areas == AREAS_GENERAL) {
              return {
                _id: a._id,
                activo: a.is_active,
                codigo: a.codigo,
                nombre_comercial: a.nombre_comercial,
                razon_social: a.razon_social,
                grupo: a.grupos?.[0]?.name || "",
                idGrupo: a.grupos?.[0]?._id || "",
                departamento: a.departamentosClientes?.[0]?.name || "",
                idDepartamento: a.departamentosClientes?.[0]?._id || "",
                vendedor: a.vendedor?.[0]
                  ? `${a.vendedor[0].nombre || ""} ${a.vendedor[0].apellido || ""}`
                  : "",
                idVendedor: a.vendedor?.[0]?._id || "",
                area: a.areas?.[0]?.name || "",
                idArea: a.areas?.[0]?._id || "",
                // POOL T unificado. El pool K quedó congelado por decisión del
                // negocio (contiene valores históricos que ya no reflejan la
                // realidad); NO sumar cargosk/abonosk/saldok aquí.
                cargos: parseFloat(a.cargos || 0),
                abonos: parseFloat(a.abonos || 0),
                saldo: parseFloat(a.saldo || 0),
                cliente: `${a.codigo || ""} / ${a.nombre_comercial || ""}`,
                plazo: a.plazo,
                empresa: a.empresas?.[0]?.name || "",
                idEmpresa: a.empresas?.[0]?._id || "",
              };
            // } else if (user.areas == a.areas[0]._id) {
            //   return {
            //     _id: a._id,
            //     activo: a.is_active,
            //     codigo: a.codigo,
            //     nombre_comercial: a.nombre_comercial,
            //     razon_social: a.razon_social,
            //     grupo: a.grupos[0].name,
            //     idGrupo: a.grupos[0]._id,
            //     departamento: a.departamentosClientes[0].name,
            //     idDepartamento: a.departamentosClientes[0]._id,
            //     vendedor: a.vendedor[0].nombre + " " + a.vendedor[0].apellido,
            //     idVendedor: a.vendedor[0]._id,
            //     area: a.areas[0].name,
            //     idArea: a.areas[0]._id,
            //     cargos: parseFloat(a.cargos),
            //     abonos: parseFloat(a.abonos),
            //     saldo: parseFloat(a.saldo),
            //     cliente: a.codigo + " / " + a.nombre_comercial,
            //     plazo: a.plazo,
            //   };
            // }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        setClientes(allClientes);
        setComments(dataFinal);

        //
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_GRUPOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allGrupos = response.data;
        setGrupos(allGrupos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_EMPRESAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allEmpresas = response.data;
        setEmpresas(allEmpresas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_DEPARTAMENTOS_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allDepartamentos = res.data;
        setDepartamentos(allDepartamentos);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });

    let SI = movimientos
      .map((c) => {
        if (selectedFechaInicio) {
          if (
            (selectedFechaInicio == "" || selectedFechaInicio > c.fecha)
          ) {
            return c.cargo - c.abono;
          }
        } else {
          return 0;
        }
      })
      .filter(function (el) {
        return el != null;
      });

    let TC = SI.reduce((t, total, index) => t + total, 0);

    setSaldoInicial(TC);
  }, [user, movimientos, selectedFechaInicio]);

  const ListaClientes = comments.sort((a, b) =>
    a.nombre_comercial > b.nombre_comercial ? 1 : -1
  );

  function PDFTabla() {
    const data = comments.map((a) => {
      if (
        (vendedor == "" || vendedor == a.idVendedor) &&
        (selectedEmpresa == "" || selectedEmpresa == a.idEmpresa) &&
        (selectedDepartamento == "" || selectedDepartamento == a.idDepartamento) &&
        (activo == "" || activo == a.activo)
      ) {
        // let totalCargos = 0;
        // let totalAbonos = 0;
        // let totalSaldo = 0;
        return [
          a.codigo,
          a.nombre_comercial,
          // a.area,
          // a.grupo,
          // a.departamento,
          a.vendedor,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Estado de Cuenta`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Cliente",
          // "Almacen",
          // "Grupo",
          // "Departamento",
          "Vendedor",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          // "",
          // "",
          // "",
          // "",
          // "",
          // "Totales",
          // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargos),
          // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonos),
          // new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldo),
        ],
      ],
      showFoot: "lastPage",
    });
    abrePDF(doc, `EstadosDeCuenta.pdf`);
  }

  function excel() {
    const dataExcel = comments.map((a) => {
      if (
        (vendedor == "" || vendedor == a.idVendedor) &&
        (selectedEmpresa == "" || selectedEmpresa == a.idEmpresa) &&
        (selectedDepartamento == "" || selectedDepartamento == a.idDepartamento) &&
        (activo == "" || activo == a.activo)
      ) {
        return {
          Codigo: a.codigo,
          Cliente: a.nombre_comercial,
          Vendedor: a.vendedor,
          Cargos: a.cargos,
          Abonos: a.abonos,
          Saldo: a.saldo,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "EstadoCuenta";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuenta",
        sheetFilter: [
          "Codigo",
          "Cliente",
          "Vendedor",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
        sheetHeader: [
          "Codigo",
          "Cliente",
          "Vendedor",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let totalCargos = 0;
    let totalAbonos = 0;
    let totalSaldo = 0;
    const data = comments.map((a) => {
      if (
        (vendedor == "" || vendedor == a.idVendedor) &&
        (selectedEmpresa == "" || selectedEmpresa == a.idEmpresa) &&
        (selectedDepartamento == "" || selectedDepartamento == a.idDepartamento) &&
        (activo == "" || activo == a.activo)
      ) {
        return [
          a.codigo,
          a.nombre_comercial,
          a.area,
          a.grupo,
          a.vendedor,
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.saldo),
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 18);
    doc.text(`Estado de Cuenta`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Cliente",
          "Almacen",
          "Grupo",
          "Vendedor",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonos),
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldo),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: "EstadoCuenta.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras los saldos de los clientes.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Nombre Comercial", field: "nombre_comercial", sortable: true },
    { name: "Empresa", field: "empresa", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    // { name: "Grupo", field: "grupo", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Cargos", field: "cargos", sortable: true },
    { name: "Abonos", field: "abonos", sortable: true },
    { name: "Saldo", field: "saldo", sortable: true },
    { name: "Estado Cuenta", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.nombre_comercial
            .toLowerCase()
            .includes(search.toLowerCase()) ||
          comment.departamento.toLowerCase().includes(search.toLowerCase()) ||
          comment.grupo.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.empresa.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigo.toString().includes(search) ||
          comment.cargos.toString().includes(search) ||
          comment.abonos.toString().includes(search) ||
          comment.saldo.toString().includes(search)
      );
    }
    if (vendedor) {
      computedComments = computedComments.filter((e) =>
        e.idVendedor.includes(vendedor)
      );
    }
    if (selectedDepartamento) {
      computedComments = computedComments.filter((e) =>
        e.idDepartamento.includes(selectedDepartamento)
      );
    }
    if (selectedEmpresa) {
      computedComments = computedComments.filter((e) =>
        e.idEmpresa.includes(selectedEmpresa)
      );
    }
    // W17: filtro última fecha en 0 (liquidados vs con saldo)
    if (filtroLiquidado === "Liquidado") {
      computedComments = computedComments.filter((e) => parseFloat(e.saldo || 0) <= 0);
    } else if (filtroLiquidado === "ConSaldo") {
      computedComments = computedComments.filter((e) => parseFloat(e.saldo || 0) > 0);
    }
    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }
    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }

    let car = computedComments.map((c) => parseFloat(c.cargos));
    let TCar = car.reduce((t, cargos, index) => t + cargos, 0);
    setTotalTotalCargos(TCar);

    let abo = computedComments.map((c) => parseFloat(c.abonos));
    let TAbo = abo.reduce((t, abonos, index) => t + abonos, 0);
    setTotalTotalAbonos(TAbo);

    let sal = computedComments.map((c) => parseFloat(c.saldo));
    let TSal = sal.reduce((t, saldo, index) => t + saldo, 0);
    setTotalTotalSaldo(TSal);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "codigo" &&
      sorting.field != "cargos" &&
      sorting.field != "abonos" &&
      sorting.field != "saldo"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "codigo" ||
        sorting.field == "cargos" ||
        sorting.field == "abonos" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "codigo" ||
        sorting.field == "cargos" ||
        sorting.field == "abonos" ||
        sorting.field == "saldo")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    vendedor,
    activo,
    selectedDepartamento,
    selectedArea,
    selectedEmpresa,
    filtroLiquidado
  ]);

  async function jalaMov(id, cliente, plazo, saldo, nombreComercial, clave) {
    await axios
      .get(`${URL_ESTADO_CUENTA}/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        setMovimientos(allVentas);
        //
      })
      .catch((err) => {
        console.log(err);
      });
      console.log(cliente)
    setNombreCliente(cliente);
    setNombreComercialCliente(nombreComercial);
    setClaveCliente(clave);
    setIdCliente(id);
    setSaldo(saldo);
    setPlazo(plazo);
    toggle();
  }

  async function jalaMovAgrupado(id, cliente, plazo, saldo, nombreComercial, clave) {
    await axios
      .get(`${URL_ESTADO_CUENTA}Agrupado/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        setMovimientos(allVentas);
        //
      })
      .catch((err) => {
        console.log(err);
      });
      setNombreCliente(cliente);
      setNombreComercialCliente(nombreComercial);
      setClaveCliente(clave);
      setIdCliente(id);
      setSaldo(saldo);
      setPlazo(plazo);
    toggleAgrupado();
  }

  async function jalaMovGlobal(id, cliente, plazo, saldo, nombreComercial, clave) {
    await axios
      .get(`${URL_ESTADO_CUENTA}Global/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allVentas = response.data;
        setMovimientos(allVentas);
        //
      })
      .catch((err) => {
        console.log(err);
      });
      setNombreCliente(cliente);
      setNombreComercialCliente(nombreComercial);
      setClaveCliente(clave);
      setIdCliente(id);
      setSaldo(saldo);
      setPlazo(plazo);
    toggleGlobal();
  }

  // C12: EstadoCuenta por Surtido
  async function jalaMovPorSurtido(id, cliente, plazo, saldo, nombreComercial, clave) {
    await axios
      .get(`${URL_ESTADO_CUENTA}PorSurtido/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const data = response.data || {};
        // Soporta shape nuevo {grupos, anticipos} y el previo (array plano)
        if (Array.isArray(data)) {
          setGruposPorSurtido(data);
          setAnticiposPorSurtido([]);
        } else {
          setGruposPorSurtido(Array.isArray(data.grupos) ? data.grupos : []);
          setAnticiposPorSurtido(Array.isArray(data.anticipos) ? data.anticipos : []);
        }
      })
      .catch((err) => {
        console.log(err);
        setGruposPorSurtido([]);
        setAnticiposPorSurtido([]);
      });
    setNombreCliente(cliente);
    setNombreComercialCliente(nombreComercial);
    setClaveCliente(clave);
    setIdCliente(id);
    setSaldo(saldo);
    setPlazo(plazo);
    // D8: vendedor del cliente, requerido al crear el abono
    const cteRow = (comments || []).find((c) => c._id === id);
    setVendedorCliente(cteRow?.idVendedor || "");
    togglePorSurtido();
  }

  // PDF Mail Excel Cliente
  // let saldoParcial = saldoInicial;
  // let totalCargosEdoCte = 0;
  // let totalAbonosEdoCte = 0;
  // let totalSaldoEdoCte = 0;


async function PDFOC() {
  let saldoParcial = saldoInicial;
  let totalCargosEdoCte = 0;
  let totalAbonosEdoCte = 0;
  let totalBonificacionesEdoCte = 0;
  let totalDevolucionesEdoCte = 0;
  let totalSaldoEdoCte = 0;
  let totalVencidoEdoCte = 0;

  // Detección de renglones vencidos (mismo criterio que la tabla en pantalla)
  const oneDayPDF = 24 * 60 * 60 * 1000;
  const secondDatePDF = new Date();
  const vencidasSet = new Set();
  let bodyIdxPDF = 0;

  const data = movimientos.map((a) => {
    if (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha) {
      totalCargosEdoCte += a.cargo;
      totalAbonosEdoCte += a.abono;
      totalBonificacionesEdoCte += a.bonificacion;
      totalDevolucionesEdoCte += a.devolucion;
      totalSaldoEdoCte =
        totalCargosEdoCte -
        totalAbonosEdoCte -
        totalBonificacionesEdoCte -
        totalDevolucionesEdoCte;

      saldoParcial =
        saldoParcial + a.cargo - a.abono - a.bonificacion - a.devolucion;

      const formatUSD = (v) =>
        v > 0
          ? new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(v)
          : "";

      const firstDate = new Date(a.fecha);
      const diffDays = Math.round(
        Math.ceil((secondDatePDF - firstDate) / oneDayPDF)
      );
      const vencido =
        (a.movimiento === "Venta" || a.movimiento === "Nota Cargo") &&
        a.saldo > 0 &&
        diffDays > plazo;
      if (vencido) {
        vencidasSet.add(bodyIdxPDF);
        totalVencidoEdoCte += Number(a.saldo || 0);
      }
      bodyIdxPDF++;

      return [
        a.numero,
        a.fecha,
        a.movimiento,
        a.observaciones,
        a.banco,
        formatUSD(a.cargo),
        formatUSD(a.abono),
        formatUSD(a.bonificacion),
        formatUSD(a.devolucion),
        new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
      ];
    }
  });

  const dataPDFLimpia = data.filter(Boolean);

  // === PDF LANDSCAPE ===
  const doc = new jsPDF("landscape", "mm", "a4", true);
  var img = new Image();
  const backgroundColor = ["#d1d2d4"];
  const backgroundColorBoxBlack = ["#231f20"];
  const backgroundColorBoxPurple = ["#B02307"];
  const margins = { left: 5, right: 5 };

  // === Logo ===
  img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img, "png", 15, 5, 33, 20);

  // === Cabecera ===
  doc.setFillColor(...backgroundColor);
  doc.rect(5, 40, 287, 6, "F"); // más ancho por landscape
  doc.setFontSize(12);
  doc.setTextColor("#000000");
  doc.text(`Tel: 55 1234 5678`, 8, 44);
  doc.text(`Cliente: ${nombreComercialCliente}`, 8, 52);
  doc.text(`Clave: ${claveCliente}`, 260, 52);

  // === Caja superior negra y naranja ===
  doc.setFillColor(...backgroundColorBoxBlack);
  doc.rect(160, 4, 135, 22, "F"); // adaptado al ancho landscape
  doc.setFillColor(...backgroundColorBoxPurple);
  doc.rect(125, 4, 35, 22, "F");
  doc.setTextColor("#ffffff");
  doc.setFontSize(14);
  doc.text(`Estado de Cuenta`, 180, 15);

  // === Estilos columnas ===
  const columnStyles = {
    0: { fontSize: 9, textColor: "#000000", halign: "center" },
    1: { fontSize: 9, textColor: "#000000", halign: "center" },
    2: { fontSize: 9, textColor: "#000000", halign: "center" },
    3: { fontSize: 9, textColor: "#000000", halign: "center", cellWidth: 40 },
    4: { fontSize: 9, textColor: "#000000", halign: "center", cellWidth: 35 },
    5: { fontSize: 9, textColor: "#000000", halign: "right" },
    6: { fontSize: 9, textColor: "#f40903", halign: "right" },
    7: { fontSize: 9, textColor: "#f40903", halign: "right" },
    8: { fontSize: 9, textColor: "#f40903", halign: "right" },
    9: { fontSize: 9, textColor: "#030af4", halign: "right" },
  };

  // === Tabla principal ===
  doc.autoTable({
    head: [
      [
        "FOLIO",
        "FECHA",
        "MOVIMIENTO",
        "OBSERVACIONES",
        "BANCO",
        "CARGOS",
        "ABONOS",
        "BONIFICACIONES",
        "DEVOLUCIONES",
        "SALDO",
      ],
    ],
    body: dataPDFLimpia,
    startY: 58,
    headStyles: {
      fillColor: ["#B02307"],
      lineWidth: 0,
      halign: "center",
      valign: "middle",
      fontSize: 8,
    },
    columnStyles: columnStyles,
    margin: margins,
    theme: "grid",
    // Pinta rojo las filas vencidas (mismo criterio que la tabla en pantalla)
    didParseCell: function (data) {
      if (data.section === "body" && vencidasSet.has(data.row.index)) {
        data.cell.styles.fillColor = [237, 140, 140];
      }
    },
  });

  // === Totales generales del cliente (mismo bloque que el PDF por surtido) ===
  {
    const fmtT = (n) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 2,
      }).format(Number(n) || 0);

    let cursorTot = (doc.lastAutoTable?.finalY || 58) + 6;

    doc.setFillColor("#B02307");
    doc.rect(margins.left, cursorTot, 287, 6, "F");
    doc.setTextColor("#ffffff");
    doc.setFontSize(11);
    doc.text("Totales generales del cliente", margins.left + 3, cursorTot + 4.5);
    doc.setTextColor("#000000");
    cursorTot += 8;

    doc.autoTable({
      body: [
        [
          { content: "Total Cargos", styles: { halign: "right", fontStyle: "bold" } },
          { content: fmtT(totalCargosEdoCte), styles: { halign: "right", fontStyle: "bold" } },
        ],
        [
          { content: "Total Abonos", styles: { halign: "right", fontStyle: "bold" } },
          {
            content: fmtT(
              totalAbonosEdoCte + totalBonificacionesEdoCte + totalDevolucionesEdoCte
            ),
            styles: { halign: "right", fontStyle: "bold", textColor: "#f40903" },
          },
        ],
        [
          { content: "Saldo Vencido", styles: { halign: "right", fontStyle: "bold" } },
          {
            content: fmtT(totalVencidoEdoCte),
            styles: { halign: "right", fontStyle: "bold", textColor: "#f40903" },
          },
        ],
        [
          { content: "Saldo General", styles: { halign: "right", fontStyle: "bold" } },
          { content: fmtT(totalSaldoEdoCte), styles: { halign: "right", fontStyle: "bold" } },
        ],
      ],
      startY: cursorTot,
      columnStyles: {
        0: { fontSize: 10, cellWidth: 220 },
        1: { fontSize: 10, cellWidth: 67 },
      },
      margin: margins,
      theme: "grid",
    });
  }

  abrePDF(doc, `EdoCtaCliente-${nombreCliente}.pdf`);
}


// C12: PDF por Surtido - se ve como el modal: una tabla por surtido
// (cabecera roja si vencido) + sección de anticipos no aplicados al final.
// Sólo se conserva el encabezado (logo + cajas + título) estilo PDFOC.
async function PDFOCPorSurtido() {
  const fmtUSD = (v) =>
    v > 0
      ? new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(v)
      : "";
  const fmt = (v) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(v || 0));

  const doc = new jsPDF("landscape", "mm", "a4", true);
  var img = new Image();
  const backgroundColor = ["#d1d2d4"];
  const backgroundColorBoxBlack = ["#231f20"];
  const backgroundColorBoxPurple = ["#B02307"];
  const margins = { left: 5, right: 5 };

  // === Encabezado (idéntico al de PDFOC) ===
  img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
  doc.addImage(img, "png", 15, 5, 33, 20);
  doc.setFillColor(...backgroundColor);
  doc.rect(5, 40, 287, 6, "F");
  doc.setFontSize(12);
  doc.setTextColor("#000000");
  doc.text(`Tel: 55 1234 5678`, 8, 44);
  doc.text(`Cliente: ${nombreComercialCliente}`, 8, 52);
  doc.text(`Clave: ${claveCliente}`, 260, 52);
  doc.setFillColor(...backgroundColorBoxBlack);
  doc.rect(160, 4, 135, 22, "F");
  doc.setFillColor(...backgroundColorBoxPurple);
  doc.rect(125, 4, 35, 22, "F");
  doc.setTextColor("#ffffff");
  doc.setFontSize(14);
  doc.text(`Estado de Cuenta por Surtido`, 165, 15);

  const columnStyles = {
    0: { fontSize: 8, textColor: "#000000", halign: "center" },
    1: { fontSize: 8, textColor: "#000000", halign: "center" },
    2: { fontSize: 8, textColor: "#000000", halign: "center" },
    3: { fontSize: 8, textColor: "#000000", halign: "center", cellWidth: 40 },
    4: { fontSize: 8, textColor: "#000000", halign: "center", cellWidth: 35 },
    5: { fontSize: 8, textColor: "#000000", halign: "right" },
    6: { fontSize: 8, textColor: "#f40903", halign: "right" },
    7: { fontSize: 8, textColor: "#f40903", halign: "right" },
    8: { fontSize: 8, textColor: "#f40903", halign: "right" },
    9: { fontSize: 8, textColor: "#030af4", halign: "right" },
  };
  const headCols = [
    "FOLIO",
    "FECHA",
    "MOVIMIENTO",
    "OBSERVACIONES",
    "BANCO/FACTURA",
    "CARGOS",
    "ABONOS",
    "BONIFICACIONES",
    "DEVOLUCIONES",
    "SALDO",
  ];

  // === Una tabla por surtido ===
  let cursorY = 58;
  const grupos = gruposPorSurtido.filter(
    (g) => g && g.surtido && (!selectedFechaInicio || selectedFechaInicio <= g.surtido.fecha)
  );

  grupos.forEach((g) => {
    const s = g.surtido;
    const movs = [...(g.movimientos || [])].sort((a, b) =>
      a.fecha > b.fecha ? 1 : -1
    );

    // fila 0 = "Venta" (cabecera del surtido)
    let saldoRun = Number(s.total_general || 0);
    const rows = [];
    rows.push([
      s.idSurtido,
      s.fecha,
      "Venta",
      s.observaciones || "",
      s.noFactura || "NA",
      fmt(saldoRun),
      "",
      "",
      "",
      fmt(saldoRun),
    ]);

    for (const m of movs) {
      const ab = Number(m.abono || 0);
      const bo = Number(m.bonificacion || 0);
      const dv = Number(m.devolucion || 0);
      saldoRun = saldoRun - ab - bo - dv;
      rows.push([
        m.numero || "",
        m.fecha,
        m.movimiento,
        m.observaciones || "",
        m.banco || "NA",
        "",
        fmtUSD(ab),
        fmtUSD(bo),
        fmtUSD(dv),
        fmt(saldoRun),
      ]);
    }

    // Foot con "Saldo Surtido"
    const footLabel = `Saldo Surtido${s.vencido ? ` (Vencido ${s.diasVencido}d)` : ""}`;
    const footRow = [
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      { content: footLabel, styles: { halign: "right", fontStyle: "bold" } },
      { content: fmt(Number(s.saldo || 0)), styles: { halign: "right", fontStyle: "bold" } },
    ];

    doc.autoTable({
      head: [headCols],
      body: rows,
      foot: [footRow],
      startY: cursorY,
      headStyles: {
        fillColor: s.vencido ? [237, 140, 140] : ["#B02307"],
        textColor: s.vencido ? "#000000" : "#ffffff",
        lineWidth: 0,
        halign: "center",
        valign: "middle",
        fontSize: 8,
      },
      footStyles: {
        fillColor: ["#7f7f7f"],
        textColor: "#ffffff",
        fontSize: 8,
      },
      columnStyles: columnStyles,
      margin: margins,
      theme: "grid",
      // Fila 0 (Venta) también en rojo si el surtido está vencido
      didParseCell: function (data) {
        if (data.section === "body" && s.vencido && data.row.index === 0) {
          data.cell.styles.fillColor = [237, 140, 140];
        }
      },
    });

    cursorY = doc.lastAutoTable.finalY + 4;
  });

  // === Anticipos no aplicados ===
  if (anticiposPorSurtido && anticiposPorSurtido.length > 0) {
    // Título de sección (mismo ancho que las tablas de arriba)
    doc.setFillColor(...backgroundColorBoxPurple);
    doc.rect(margins.left, cursorY, 287, 6, "F");
    doc.setTextColor("#ffffff");
    doc.setFontSize(11);
    doc.text("Anticipos no aplicados", margins.left + 3, cursorY + 4.5);
    cursorY += 8;

    const anticiposRows = anticiposPorSurtido.map((a) => [
      a.idAnticipo,
      a.fecha,
      a.banco || "NA",
      a.observaciones || "",
      fmt(a.importe),
      fmt(a.saldo),
    ]);
    const totalAntSaldo = anticiposPorSurtido.reduce(
      (t, a) => t + Number(a.saldo || 0),
      0
    );

    doc.autoTable({
      head: [["FOLIO", "FECHA", "BANCO", "OBSERVACIONES", "IMPORTE", "SALDO"]],
      body: anticiposRows,
      foot: [
        [
          "",
          "",
          "",
          { content: "TOTAL SALDO ANTICIPOS", styles: { halign: "right", fontStyle: "bold" } },
          "",
          { content: fmt(totalAntSaldo), styles: { halign: "right", fontStyle: "bold" } },
        ],
      ],
      startY: cursorY,
      headStyles: {
        fillColor: ["#B02307"],
        textColor: "#ffffff",
        lineWidth: 0,
        halign: "center",
        valign: "middle",
        fontSize: 8,
      },
      footStyles: {
        fillColor: ["#7f7f7f"],
        textColor: "#ffffff",
        fontSize: 8,
      },
      columnStyles: {
        0: { fontSize: 8, halign: "center" },
        1: { fontSize: 8, halign: "center" },
        2: { fontSize: 8, halign: "center" },
        3: { fontSize: 8, halign: "center", cellWidth: 80 },
        4: { fontSize: 8, halign: "right" },
        5: { fontSize: 8, halign: "right", textColor: "#030af4" },
      },
      margin: margins,
      theme: "grid",
    });
  }

  // === Totales generales del cliente ===
  if (grupos.length > 0) {
    const totCargos = grupos.reduce(
      (t, g) => t + Number(g?.surtido?.total_general || 0),
      0
    );
    const totAbonos = grupos.reduce((t, g) => {
      const movs = Array.isArray(g?.movimientos) ? g.movimientos : [];
      return (
        t +
        movs.reduce(
          (s, m) =>
            s +
            Number(m.abono || 0) +
            Number(m.bonificacion || 0) +
            Number(m.devolucion || 0),
          0
        )
      );
    }, 0);
    const totSaldo = grupos.reduce(
      (t, g) => t + Number(g?.surtido?.saldo || 0),
      0
    );
    const totVencido = grupos.reduce(
      (t, g) =>
        t + (g?.surtido?.vencido ? Number(g?.surtido?.saldo || 0) : 0),
      0
    );

    cursorY = (doc.lastAutoTable?.finalY || cursorY) + 6;

    doc.setFillColor(...backgroundColorBoxPurple);
    doc.rect(margins.left, cursorY, 287, 6, "F");
    doc.setTextColor("#ffffff");
    doc.setFontSize(11);
    doc.text("Totales generales del cliente", margins.left + 3, cursorY + 4.5);
    cursorY += 8;

    doc.autoTable({
      body: [
        [
          { content: "Total Cargos", styles: { halign: "right", fontStyle: "bold" } },
          { content: fmt(totCargos), styles: { halign: "right", fontStyle: "bold" } },
        ],
        [
          { content: "Total Abonos", styles: { halign: "right", fontStyle: "bold" } },
          {
            content: fmt(totAbonos),
            styles: { halign: "right", fontStyle: "bold", textColor: "#f40903" },
          },
        ],
        [
          { content: "Saldo Vencido", styles: { halign: "right", fontStyle: "bold" } },
          {
            content: fmt(totVencido),
            styles: { halign: "right", fontStyle: "bold", textColor: "#f40903" },
          },
        ],
        [
          { content: "Saldo General", styles: { halign: "right", fontStyle: "bold" } },
          { content: fmt(totSaldo), styles: { halign: "right", fontStyle: "bold" } },
        ],
      ],
      startY: cursorY,
      columnStyles: {
        0: { fontSize: 10, cellWidth: 220 },
        1: { fontSize: 10, cellWidth: 67 },
      },
      margin: margins,
      theme: "grid",
    });
  }

  abrePDF(doc, `EdoCtaPorSurtido-${nombreCliente}.pdf`);
}


  async function PDFOCGlobal() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;

   await axios
      .get(`${URL_DASHBOARDS}AntiguedadSaldosVencidoEdoCta/${idCliente}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allAntSaldos = response.data;

      let totalTreinta = 0;
      let totalSesenta = 0;
      let totalNoventa = 0;
      let totalMasNoventa = 0;
      let totalEnTiempo = 0;

      const dataAS = allAntSaldos.map((a) => {
        totalTreinta += isFinite(a.treinta) ? a.treinta : 0;
        totalSesenta += isFinite(a.sesenta) ? a.sesenta : 0;
        totalNoventa += isFinite(a.noventa) ? a.noventa : 0;
        totalMasNoventa += isFinite(a.masnoventa) ? a.masnoventa : 0;
        totalEnTiempo += isFinite(a.enTiempo) ? a.enTiempo : 0;
        const fechaVencimientoDate = new Date(a.fechaVencimiento);

        const fechaVencimientoFormatted = fechaVencimientoDate.toLocaleDateString('en-GB');
      
        const treintaFormatted = isFinite(a.treinta) ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.treinta) : '';
        const sesentaFormatted = isFinite(a.sesenta) ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.sesenta) : '';
        const noventaFormatted = isFinite(a.noventa) ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.noventa) : '';
        const masnoventaFormatted = isFinite(a.masnoventa) ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.masnoventa) : '';
        const enTiempoFormatted = isFinite(a.enTiempo) ? new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.enTiempo) : '';
      
        return [
          a.folio,
          fechaVencimientoFormatted,
          treintaFormatted,
          sesentaFormatted,
          noventaFormatted,
          masnoventaFormatted,
          enTiempoFormatted
        ];
      });
      const dataPDFAS = Object.values(dataAS);
      const dataPDFLimpiaAS = dataPDFAS.filter(function (el) {
        return el != null;
      });

      const totalVencido = totalTreinta + totalSesenta + totalNoventa + totalMasNoventa;

    // Detección de renglones vencidos para el PDF Global
    const oneDayPDFG = 24 * 60 * 60 * 1000;
    const secondDatePDFG = new Date();
    const vencidasSetG = new Set();
    let bodyIdxPDFG = 0;

    const data = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        totalCargosEdoCte = totalCargosEdoCte + a.cargo;
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
        saldoParcial = saldoParcial + a.cargo - a.abono;
        const cargos = a.cargo > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo): '';
        const abonos = a.abono > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono): '';
        var saldoParcialFormato =
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial);

        const firstDate = new Date(a.fecha);
        const diffDays = Math.round(
          Math.ceil((secondDatePDFG - firstDate) / oneDayPDFG)
        );
        const vencido =
          (a.movimiento === "Venta" || a.movimiento === "Nota Cargo") &&
          a.saldo > 0 &&
          diffDays > plazo;
        if (vencido) vencidasSetG.add(bodyIdxPDFG);
        bodyIdxPDFG++;

        return [
          a.numero,
          a.fecha,
          a.movimiento,
          a.observaciones,
          a.banco,
          cargos,
          abonos,
          saldoParcialFormato,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
  //   const columnStyles = [
  //     { fontSize: 9,textColor: ["#000000"] ,halign: 'center'},
  //     { fontSize: 9,textColor: ["#000000"] ,halign: 'center'},
  //     { fontSize: 9,textColor: ["#000000"] ,halign: 'center'},
  //     { fontSize: 9,textColor: ["#000000"] ,halign: 'center'},
  //     { fontSize: 9,textColor: ["#000000"] ,halign: 'center'},
  //     { fontSize: 9,textColor: ["#000000"] ,halign: 'right'}, //Cargos - Negro
  //     { fontSize: 9,textColor: ["#f40903"] ,halign: 'right'}, // Abonos - Rojo
  //     { fontSize: 9,textColor: ["#030af4"] ,halign: 'right'}, // Saldos - Azul a favor
  // ];

    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    var img2 = new Image();
    const backgroundColor = ["#d1d2d4"];
    const backgroundColorBoxBlack = ["#231f20"];
    const backgroundColorBoxPurple = ["#B02307"];
    const margins = {  left: 5, right: 5 };

    img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img, "png", 15, 5, 33, 20);
    
    doc.setFillColor(...backgroundColor);
    doc.setFontSize(12);
    doc.rect(5, 40, 200, 6, 'F');
    doc.setTextColor("#000000");
    doc.text(`Tel: 55 1234 5678`,8, 44);
    
    doc.setTextColor("#000000");
    doc.text(`Cliente: ${nombreComercialCliente}`,8, 52)
    doc.text(`Clave: ${claveCliente}`,176, 52)

    doc.setFillColor(...backgroundColorBoxBlack);
    doc.rect(100, 4, 105, 22, 'F');
    doc.setFillColor(...backgroundColorBoxPurple);
    doc.rect(74, 4, 25, 22, 'F');
    doc.setTextColor("#ffffff");
    doc.text(`Estado de Cuenta`,130, 15);

    const columnStyles = {
      0: { fontSize: 9, textColor: "#000000", halign: 'center' }, // FOLIO
      1: { fontSize: 9, textColor: "#000000", halign: 'center' }, // FECHA
      2: { fontSize: 9, textColor: "#000000", halign: 'center' }, // MOVIMIENTO
      3: { fontSize: 9, textColor: "#000000", halign: 'center', cellWidth: 35 }, // OBSERVACIONES - Limita ancho
      4: { fontSize: 9, textColor: "#000000", halign: 'center', cellWidth: 35 }, // BANCO
      5: { fontSize: 9, textColor: "#000000", halign: 'right' }, // CARGOS - Negro
      6: { fontSize: 9, textColor: "#f40903", halign: 'right' }, // ABONOS - Rojo
      7: { fontSize: 9, textColor: "#030af4", halign: 'right' }, // SALDOS - Azul a favor
    };

    doc.autoTable({
      head: [
        [
          "FOLIO",
          "FECHA",
          "MOVIMIENTO",
          "OBSERVACIONES",
          "BANCO",
          "CARGOS",
          "ABONOS",
          "SALDO",
        ],
      ],
      body: dataPDFLimpia,
      startY: 55,
      headStyles: {
        // fillColor: ["#B02307"],
        fillColor: ["#B02307"],
        lineWidth: 0,
        halign: 'center',
        valign: 'middle',
        fontSize: 8
      },
      footStyles: {
        // fillColor: ["#B02307"],
        fillColor: ["#B02307"],
      },
      columnStyles: columnStyles,
      margin: margins,
      theme:"grid",
      // Pinta rojo las filas vencidas (mismo criterio que la tabla en pantalla)
      didParseCell: function (data) {
        if (data.section === "body" && vencidasSetG.has(data.row.index)) {
          data.cell.styles.fillColor = [237, 140, 140];
        }
      },
    });

    const columnStylesAntiguedad = [
      { fontSize: 9,textColor: ["#000000"] ,halign: 'center'},
      { fontSize: 9,textColor: ["#000000"] ,halign: 'center'},
      { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
      { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
      { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
      { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
      { fontSize: 9,textColor: ["#000000"] ,halign: 'right'},
  ];

  //   doc.addPage()
  //   doc.setFillColor(...backgroundColorBoxPurple);
  //   doc.rect(8, 8, 70, 10, 'F');
  //   doc.setFontSize(14);
  //   doc.setTextColor("#ffffff");
  //   doc.text(`ANTIGUEDAD DE SALDOS`,10, 15);
  //   doc.autoTable({
  //     head: [
  //       [
  //         "FOLIO",
  //         "FECHA DE VENCIMIENTO",
  //         "1 A 30 DIAS",
  //         "31 A 60 DIAS",
  //         "61 A 90 DIAS",
  //         "+ 90 DIAS",
  //         "EN TIEMPO",
  //       ],
  //     ],
  //     body: dataPDFLimpiaAS,
  //     startY: 20,
  //     headStyles: {
  //       fillColor: ["#B02307"],
  //       lineWidth: 0,
  //       halign: 'center',
  //       valign: 'middle',
  //       fontSize: 8
  //     },
  //     footStyles: {
  //       fillColor: ["#B02307"],
  //     },
  //     columnStyles:columnStylesAntiguedad,
  //     foot: [
  //       [
  //         "",
  //         "Total",
  //         new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTreinta),
  //         new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSesenta),
  //         new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalNoventa),
  //         new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalMasNoventa),
  //         new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalEnTiempo),
  //       ]
  //     ],
  //     showFoot: "lastPage",
  //     margin: margins,
  //     theme:"grid",
  //   });

  //   let totalVencidos = totalTreinta + totalSesenta + totalNoventa + totalMasNoventa;
  //   let totalResumen = totalVencidos + totalEnTiempo;
    
  //   // Asumimos que totalVencidos y totalEnTiempo ya están calculados correctamente como sumas de montos.
  //   let porcentajeVencidos = totalResumen > 0 ? (totalVencidos / totalResumen) : 0;
  //   let porcentajeAtiempo = totalResumen > 0 ? (totalEnTiempo / totalResumen) : 0;

  //   const resumenData = [
  //     ["Vencidos",
  //       new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalVencidos),
  //       new Intl.NumberFormat("en-US", {style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2}).format(porcentajeVencidos)],
  //     ["Al corriente",
  //       new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalEnTiempo),
  //       new Intl.NumberFormat("en-US", {style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2}).format(porcentajeAtiempo)],
  //     ["Total",
  //       new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalResumen),
  //       new Intl.NumberFormat("en-US", {style: "percent", minimumFractionDigits: 2, maximumFractionDigits: 2}).format(1)]
  //   ];

  //   const columnStylesResumen = [
  //     { fontSize: 9,textColor: ["#FFFFFF"] ,fillColor: ["#B02307"],halign: 'center'},
  //     { fontSize: 9,textColor: ["#000000"],halign: 'right'},
  //     { fontSize: 9,textColor: ["#000000"],halign: 'center'},
  // ];

  //   doc.autoTable({
  //     head: [
  //       [
  //         "",
  //         "RESUMEN DE SALDOS",
  //         ""
  //       ]
  //     ],
  //     body: resumenData,
  //     startY: doc.autoTable.previous.finalY + 10,
  //     headStyles: {
  //       fillColor: ["#B02307"],
  //       lineWidth: 0,
  //       halign: 'center',
  //       valign: 'middle',
  //       fontSize: 8
  //     },
  //     columnStyles:columnStylesResumen,
  //     showFoot: "lastPage",
  //     margin:  {  left: 5, right: 120 },
  //     theme:"grid",
  //   });

    abrePDF(doc, `EdoCtaCliente-${nombreCliente}.pdf`);

  })
  .catch((err) => {
    console.log(err);
  });
  }

  function countOfEachColumn(arr) {
  const columnCounts = [];

  if (arr.length === 0) {
    return columnCounts; // Devolver un array vacío si arr está vacío
  }

  for (let j = 2; j < arr[0].length; j++) {
    let columnCount = 0;

    for (let i = 0; i < arr.length; i++) {
      const currentValue = arr[i][j];
      if (currentValue > '') {
      columnCount += 1;
      }
    }

    columnCounts.push(columnCount);
  }

  return columnCounts ;
}


  function emailFOC() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;
    const data = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        totalCargosEdoCte = totalCargosEdoCte + a.cargo;
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
        saldoParcial = saldoParcial + a.cargo - a.abono;
        const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo);
        const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono);
        var saldoParcialFormato =
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial);
        return [
          a.fecha,
          a.movimiento,
          a.numero,
          cargos,
          abonos,
          saldoParcialFormato,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 25, 35, 15);
    // doc.setFontSize(14)
    doc.text(`Estado de Cuenta`, 15, 30);
    doc.text(`Cliente ${nombreCliente}`, 15, 37);
    doc.text(`Desde ${selectedFechaInicio}`, 15, 44);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 50,
      headStyles: {
        fillColor: ["#B02307"],
        lineWidth: 0
      },
      footStyles: {
        fillColor: ["#B02307"],
      },
      theme:"grid",
      foot: [
        [
          "",
          "",
          "",
          { content: "Saldo Anterior", colSpan: 2, styles: { halign: "left" } },
          // "Saldo Anterior",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial),
        ],
        [
          "",
          "",
          "",
          {
            content: "Cargos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdoCte),
        ],
        [
          "",
          "",
          "",
          {
            content: "Abonos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdoCte),
        ],
        [
          "",
          "",
          "",
          { content: "Saldo Actual", colSpan: 2, styles: { halign: "left" } },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: `EstadoCuenta-${nombreCliente}.pdf`,
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Estado de Cuenta de ${nombreCliente}.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail2();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  function excelFOC() {
    const dataExcel = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        return {
          Fecha: a.fecha,
          Movimiento: a.movimiento,
          Numero: a.numero,
          Cargo: a.cargo,
          Abono: a.abono,
          Cargos: a.cargos,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `EdoCtaCliente-${nombreCliente}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuenta",
        sheetFilter: [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargo",
          "Abono",
        ],
        sheetHeader: [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargo",
          "Abono",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function PDFOCAgrupado() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;

    const data = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        totalCargosEdoCte = totalCargosEdoCte + a.cargo;
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
        saldoParcial = saldoParcial + a.cargo - a.abono;
        const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo);
        const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono);
        var saldoParcialFormato =
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial);
        return [
          a.fecha,
          a.movimiento,
          a.numero,
          cargos,
          abonos,
          saldoParcialFormato,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 25, 35, 15);
    // doc.setFontSize(14)
    doc.text(`Estado de Cuenta`, 15, 30);
    doc.text(`Cliente ${nombreCliente}`, 15, 37);
    doc.text(`Desde ${selectedFechaInicio}`, 15, 44);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 50,
      headStyles: {
        fillColor: ["#B02307"],
        lineWidth: 0
      },
      footStyles: {
        fillColor: ["#B02307"],
      },
      theme:"grid",
      foot: [
        [
          "",
          "",
          "",
          { content: "Saldo Anterior", colSpan: 2, styles: { halign: "left" } },
          // "Saldo Anterior",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial),
        ],
        [
          "",
          "",
          "",
          {
            content: "Cargos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdoCte),
        ],
        [
          "",
          "",
          "",
          {
            content: "Abonos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdoCte),
        ],
        [
          "",
          "",
          "",
          { content: "Saldo Actual", colSpan: 2, styles: { halign: "left" } },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    abrePDF(doc, `EdoCtaCliente-${nombreCliente}.pdf`);
  }

  function emailFOCAgrupado() {
    let saldoParcial = saldoInicial;
    let totalCargosEdoCte = 0;
    let totalAbonosEdoCte = 0;
    let totalSaldoEdoCte = 0;
    const data = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        totalCargosEdoCte = totalCargosEdoCte + a.cargo;
        totalAbonosEdoCte = totalAbonosEdoCte + a.abono;
        totalSaldoEdoCte = totalCargosEdoCte - totalAbonosEdo;
        saldoParcial = saldoParcial + a.cargo - a.abono;
        const cargos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cargo);
        const abonos = new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.abono);
        var saldoParcialFormato =
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial);
        return [
          a.fecha,
          a.movimiento,
          a.numero,
          cargos,
          abonos,
          saldoParcialFormato,
        ];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 25, 35, 15);
    // doc.setFontSize(14)
    doc.text(`Estado de Cuenta`, 15, 30);
    doc.text(`Cliente ${nombreCliente}`, 15, 37);
    doc.text(`Desde ${selectedFechaInicio}`, 15, 44);
    doc.autoTable({
      head: [
        [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargos",
          "Abonos",
          "Saldo",
        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#B02307"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#B02307"],
          },
          theme:"grid",
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          { content: "Saldo Anterior", colSpan: 2, styles: { halign: "left" } },
          // "Saldo Anterior",
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial),
        ],
        [
          "",
          "",
          "",
          {
            content: "Cargos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdoCte),
        ],
        [
          "",
          "",
          "",
          {
            content: "Abonos del Periodo",
            colSpan: 2,
            styles: { halign: "left" },
          },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdoCte),
        ],
        [
          "",
          "",
          "",
          { content: "Saldo Actual", colSpan: 2, styles: { halign: "left" } },
          new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcial),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Estado de Cuenta",
          email: mailTo,
          fileName: `EstadoCuenta-${nombreCliente}.pdf`,
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el Estado de Cuenta de ${nombreCliente}.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail3();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setMailTo("");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        console.log(error);
      });
  }

  function excelFOCAgrupado() {
    const dataExcel = movimientos.map((a) => {
      if (
        (selectedFechaInicio == "" || selectedFechaInicio <= a.fecha)
      ) {
        return {
          Fecha: a.fecha,
          Movimiento: a.movimiento,
          Numero: a.numero,
          Cargo: a.cargo,
          Abono: a.abono,
          Bonificacion: a.bonificacion,
          Devolucion: a.devolucion,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = `EdoCtaCliente-${nombreCliente}`;

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuenta",
        sheetFilter: [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargo",
          "Abono",
          "Bonificacion",
          "Devolucion",
        ],
        sheetHeader: [
          "Fecha",
          "Movimiento",
          "Numero",
          "Cargo",
          "Abono",
          "Bonificacion",
          "Devolucion",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }


function excelAnalisisSurtidos() {
  axios
    .get(`${URL_ESTADO_CUENTA}AnalisisSurtidos`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let movs = response.data;

      // Solo los que tienen diferencia distinta de 0
      const dataFiltrada = movs.filter((a) => a.diferencia !== 0);

      const dataExcel = dataFiltrada.map((a) => {
        return {
          IDSurtido: a.idSurtido,
          Surtido: a.surtido,
          Fecha: a.fecha,
          TotalRegistrado: a.totalRegistrado,
          TotalArticulos: a.totalArticulos,
          Diferencia: a.diferencia,
        };
      });

      const option = {
        fileName: "AnalisisSurtidos_Diferencias",
        datas: [
          {
            sheetData: dataExcel,
            sheetName: "Comparativa",
            sheetFilter: [
              "IDSurtido",
              "Surtido",
              "Fecha",
              "TotalRegistrado",
              "TotalArticulos",
              "Diferencia",
            ],
            sheetHeader: [
              "IDSurtido",
              "Surtido",
              "Fecha",
              "TotalRegistrado",
              "TotalArticulos",
              "Diferencia",
            ],
          },
        ],
      };

      const toExcel = new ExportJsonExcel(option);
      toExcel.saveExcel();
    })
    .catch((err) => {
      console.log(err);
    });
}


    function excelAnalisisVentasTiendas() {

    axios
    .get(`${URL_ESTADO_CUENTA}AnalisisVentasTiendas`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
     let movs = response.data

     const dataExcel = movs.map((a) => {
        return {
          IDSurtido: a.idSurtido,
          Surtido: a.surtido,
          Total: a.total,
          Abonos: a.abonos,
          Saldo: a.saldo,
          SaldoSistema: a.saldoSistema
        };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "EstadoCuenta";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuenta",
        sheetFilter: [
          "IDSurtido",
          "Surtido",
          "Total",
          "Abonos",
          "Saldo",
          "SaldoSistema"
        ],
        sheetHeader: [
          "IDSurtido",
          "Surtido",
          "Total",
          "Abonos",
          "Saldo",
          "SaldoSistema"
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();

    })
    .catch((err) => {
      console.log(err);
    });


   
  }

     function excelAnalisisNotasCargo() {

    axios
    .get(`${URL_ESTADO_CUENTA}AnalisisNotasCargo`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
     let movs = response.data

     const dataExcel = movs.map((a) => {
        return {
          IDSurtido: a.idSurtido,
          Surtido: a.surtido,
          Total: a.total,
          Abonos: a.abonos,
          Saldo: a.saldo,
          SaldoSistema: a.saldoSistema
        };
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "EstadoCuenta";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "EstadoCuenta",
        sheetFilter: [
          "IDSurtido",
          "Surtido",
          "Total",
          "Abonos",
          "Saldo",
          "SaldoSistema"
        ],
        sheetHeader: [
          "IDSurtido",
          "Surtido",
          "Total",
          "Abonos",
          "Saldo",
          "SaldoSistema"
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();

    })
    .catch((err) => {
      console.log(err);
    });


   
  }

  let totalCargosTabla = 0;
  let totalAbonosTabla = 0;
  let totalSaldoTabla = 0;

  let saldoParcialTabla = saldoInicial;
  let totalCargosEdo = 0;
  let totalAbonosEdo = 0;
  let totalSaldoEdo = 0;

  let saldoParcialTablaAgrupado = saldoInicial;
  let totalCargosEdoAgrupado = 0;
  let totalAbonosEdoAgrupado = 0;
  let totalBonificacionesEdoAgrupado = 0;
  let totalDevolucionesEdoAgrupado = 0;
  let totalSaldoEdoAgrupado = 0;

  let saldoParcialTablaGlobal = saldoInicial;
  let totalCargosEdoGlobal = 0;
  let totalAbonosEdoGlobal = 0;
  let totalSaldoEdoGlobal = 0;

  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const secondDate = new Date(hoy);
  let saldoVencido =0

  return (
    <>
      <Header />
      <br />
      <br />
      {user.edoCtaClientes ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                  // onClick={excelAnalisisSurtidos}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <h3 align="center">Estado de Cuenta</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            {user.departamentos == AREAS_GENERAL ? (
              <Col md={2}>
                <Label>Departamento</Label>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedDepartamento}
                  onChange={(e) => {
                    setSelectedDepartamento(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {departamentos
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </Col>
            ) : undefined}
            <Col md={2}>
              <Label>Saldo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={filtroLiquidado}
                onChange={(e) => {
                  setFiltroLiquidado(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Liquidado">Liquidados (saldo 0)</option>
                <option value="ConSaldo">Con saldo</option>
              </Input>
            </Col>
            <Col md={2}>
              <Label>Empresa</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedEmpresa}
                onChange={(e) => {
                  setSelectedEmpresa(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {empresas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    // if (a.cobrador == "Si") {
                    return (
                      <option value={a._id}>
                        {a.name}
                      </option>
                    );
                    // }
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Vendedor</Label>
              <Input
                bsSize="sm"
                type="select"
                value={vendedor}
                onChange={(e) => {
                  setVendedor(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {colaboradores
                  .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                  .map((a) => {
                    // if (a.cobrador == "Si") {
                    return (
                      <option value={a._id}>
                        {a.nombre} {a.apellido}
                      </option>
                    );
                    // }
                  })}
              </Input>
            </Col>
            <Col md={2}>
              <Label>Activo</Label>
              <Input
                bsSize="sm"
                type="select"
                value={activo}
                required
                onChange={(e) => {
                  setActivo(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Selecciona</option>
                <option value="Si">Activos</option>
                <option value="No">Inactivos</option>
              </Input>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((p) => {
                totalCargosTabla = totalCargosTabla + parseFloat(p.cargos);
                totalAbonosTabla = totalAbonosTabla + parseFloat(p.abonos);
                totalSaldoTabla = totalSaldoTabla + parseFloat(p.saldo);
                {
                  return (
                    <tr>
                      <td>{p.codigo}</td>
                      <td> {p.nombre_comercial}</td>
                      <td> {p.empresa}</td>
                      <td>{p.area}</td>
                      {/* <td>{p.grupo}</td> */}
                      <td>{p.vendedor}</td>
                      <td>
                         {p.cargos > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.cargos): ''}
                      </td>
                      <td>
                        {p.abonos > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.abonos): ''}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(p.saldo)}
                      </td>
                      <td>
                        {/* <Button
                          color="info"
                          size="sm"
                          onClick={(e) =>
                            jalaMov(p._id, p.cliente, p.plazo, p.saldo, p.nombre_comercial, p.codigo)
                          }
                          id="Detalle"
                        >
                          <i class="fas fa-file-alt"></i>
                        </Button> */}

                        <Button
                          color="success"
                          size="sm"
                          onClick={(e) =>
                            jalaMovAgrupado(p._id, p.cliente, p.plazo, p.saldo, p.nombre_comercial, p.codigo)
                          }
                          id="Detalle"
                        >
                          <i class="far fa-newspaper"></i>
                        </Button>

                        {/* C12: Estado de Cuenta por Surtido (con abonos aplicados a cada nota) */}
                        <Button
                          color="danger"
                          size="sm"
                          onClick={(e) =>
                            jalaMovPorSurtido(p._id, p.cliente, p.plazo, p.saldo, p.nombre_comercial, p.codigo)
                          }
                          id="DetallePorSurtido"
                          title="Estado de Cuenta por Surtido"
                        >
                          <i class="fas fa-receipt"></i>
                        </Button>

                        {/* <Button
                          color="danger"
                          size="sm"
                          onClick={(e) =>
                            jalaMovGlobal(p._id, p.cliente, p.plazo, p.saldo, p.nombre_comercial, p.codigo)
                          }
                          id="Detalle"
                        >
                          <i class="far fa-newspaper"></i>
                        </Button> */}
                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="right">
                  TOTAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosTabla)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalSaldoTabla)}
                </td>
                <td></td>
              </tr>

              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="right">
                  TOTAL GENERAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalCargos)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalAbonos)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalTotalSaldo)}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="xxl" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <h4>Estado de Cuenta de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={2}>
              <ButtonGroup>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFOC}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={toggleMail2}
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelFOC}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>

            <Col md={2}>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Plazo {plazo} dias</Label>
                </Col>
              </Row>
            </Col>

            <Col md={3}>
              <Row>
                <Col md={3}>
                  <Label className="mr-sm-2">Fecha</Label>
                </Col>
                <Col md={6}>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
              </Row>
            </Col>


            <Col md={2}>
              <h4 align="right">
                Saldo{"  "}
                <Badge
                  id="Total"
                  color="danger"
                  className="BadgeSize badge-pill"
                >
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldo)}
                </Badge>
              </h4>
            </Col>
          </Row>
          <div className="card container">
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr align="center">
                  <th className="tituloTabla">Folio</th>
                  <th className="tituloTabla" align="left">
                    Fecha
                  </th>
                  <th className="tituloTabla">Movimiento</th>
                  <th className="tituloTabla">Cargos</th>
                  <th className="tituloTabla">Abonos</th>
                  <th className="tituloTabla">Saldo</th>
                  <th className="tituloTabla">Banco</th>
                </tr>
              </thead>
              <tbody>
                {selectedFechaInicio ? (
                  <tr>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="right">Saldo Anterior</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial)}
                    </td>
                  </tr>
                ) : undefined}
                {movimientos.map((c) => {
                  if (
                    (selectedFechaInicio == "" ||
                      selectedFechaInicio <= c.fecha)
                  ) {
                    saldoParcialTabla = saldoParcialTabla + c.cargo - c.abono;
                    totalCargosEdo = totalCargosEdo + c.cargo;
                    totalAbonosEdo = totalAbonosEdo + c.abono;
                    totalSaldoEdo = totalCargosEdo - totalAbonosEdo;
                    let firstDate = new Date(c.fecha);
                    let diffDays = Math.round(Math.ceil((secondDate - firstDate) / oneDay))
                    if((c.movimiento == "Venta" || c.movimiento == "Nota Cargo") && c.saldo > 0 &&  diffDays > plazo){
                      saldoVencido = 0
                      saldoVencido = saldoVencido + c.saldo
                      return (
                        <tr style={{backgroundColor:"#ed8c8c"}}>
                          <td align="center">{c.numero}</td>
                          <td align="center">{c.fecha}</td>
                          <td align="center">{c.movimiento}</td>
                          <td align="right">
                            {c.cargo > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.cargo): ''}
                          </td>
                          <td align="right">
                            {c.abono > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.abono): ''}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                                saldoParcialTabla
                              )}
                          </td>
                          <td align="center">{c.banco}</td>
                        </tr>
                      )
                    }else{
                    return (
                      <tr>
                        <td align="center">{c.numero}</td>
                        <td align="center">{c.fecha}</td>
                        <td align="center">{c.movimiento}</td>
                        <td align="right">
                          {c.cargo > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.cargo): ''}
                        </td>
                        <td align="right">
                          {c.abono > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.abono): ''}
                        </td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              saldoParcialTabla
                            )}
                        </td>
                        <td align="center">{c.banco}</td>
                      </tr>
                    );}
                  }
                })}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Anterior
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Cargos del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdo)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Abonos del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {"-" + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdo)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Vencido
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoVencido)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Actual
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcialTabla)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>



      <Modal
  size="xxl"
  isOpen={modalAgrupado}
  toggle={toggleAgrupado}
  style={{ maxWidth: "95%", margin: "0 auto" }}
  contentClassName="custom-modal-content"
>
        <ModalHeader toggle={toggleAgrupado}>
          <h4>Estado de Cuenta de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={2}>
              <ButtonGroup>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFOC}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={toggleMail3}
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelFOCAgrupado}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>

            <Col md={2}>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Plazo {plazo} dias</Label>
                </Col>
              </Row>
            </Col>

            <Col md={3}>
              <Row>
                <Col md={3}>
                  <Label className="mr-sm-2">Fecha</Label>
                </Col>
                <Col md={6}>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
              </Row>
            </Col>

          

            <Col md={3}>
              <h4 align="right">
                Saldo{"  "}
                <Badge
                  id="Total"
                  color="danger"
                  className="BadgeSize badge-pill"
                >
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldo)}
                </Badge>
              </h4>
            </Col>
          </Row>
          <div className="card container">
            <Table striped borderless className="table-responsive-xl">
              <thead>
                <tr align="center">
                  <th className="tituloTabla" align="left">
                    Fecha
                  </th>
                  <th className="tituloTabla">Movimiento</th>
                  <th className="tituloTabla">Observaciones</th>
                  <th className="tituloTabla">Numero</th>
                  <th className="tituloTabla">Banco</th>
                  <th className="tituloTabla">Cargos</th>
                  <th className="tituloTabla">Abonos</th>
                  <th className="tituloTabla">Bonificaciones</th>
                  <th className="tituloTabla">Devoluciones</th>
                  <th className="tituloTabla">Saldo</th>
                </tr>
              </thead>
              <tbody>
                {selectedFechaInicio ? (
                  <tr>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="right">Saldo Anterior</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial)}
                    </td>
                  </tr>
                ) : undefined}
                {movimientos.map((c) => {
                  if (
                    (selectedFechaInicio == "" ||
                      selectedFechaInicio <= c.fecha)
                  ) {
                    saldoParcialTablaAgrupado = saldoParcialTablaAgrupado + c.cargo - c.abono - c.bonificacion - c.devolucion;
                    totalCargosEdoAgrupado = totalCargosEdoAgrupado + c.cargo;
                    totalAbonosEdoAgrupado = totalAbonosEdoAgrupado + c.abono;
                    totalBonificacionesEdoAgrupado = totalBonificacionesEdoAgrupado + c.bonificacion;
                    totalDevolucionesEdoAgrupado = totalDevolucionesEdoAgrupado + c.devolucion;
                    totalSaldoEdoAgrupado = totalCargosEdoAgrupado - totalAbonosEdoAgrupado - totalBonificacionesEdoAgrupado - totalDevolucionesEdoAgrupado;
                    let firstDate = new Date(c.fecha);
                    let diffDays = Math.round(Math.ceil((secondDate - firstDate) / oneDay))
                    if((c.movimiento == "Venta" || c.movimiento == "Nota Cargo") && c.saldo > 0 &&  diffDays > plazo){
                      saldoVencido = 0
                      saldoVencido = saldoVencido + c.saldo
                      return (
                        <tr style={{backgroundColor:"#ed8c8c"}}>
                          <td align="center">{c.fecha}</td>
                          <td align="center">{c.movimiento}</td>
                          <td align="center">{c.observaciones}</td>
                          <td align="center">{c.numero}</td>
                          <td align="center">{c.banco}</td>
                          <td align="right">
                            {c.cargo > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.cargo): ''}
                          </td>
                          <td align="right">
                            {c.abono > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.abono): ''}
                          </td>
                          <td align="right">
                            {c.bonificacion > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.bonificacion): ''}
                          </td>
                          <td align="right">
                            {c.devolucion > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.devolucion): ''}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                                saldoParcialTablaAgrupado
                              )}
                          </td>
                        </tr>
                      )
                    }else{
                    return (
                      <tr>
                        <td align="center">{c.fecha}</td>
                        <td align="center">{c.movimiento}</td>
                        <td align="center">{c.observaciones}</td>
                        <td align="center">{c.numero}</td>
                        <td align="center">{c.banco}</td>
                        <td align="right">
                          {c.cargo > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.cargo): ''}
                        </td>
                        <td align="right">
                          {c.abono > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.abono): ''}
                        </td>
                        <td align="right">
                          {c.bonificacion > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.bonificacion): ''}
                        </td>
                        <td align="right">
                          {c.devolucion > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.devolucion): ''}
                        </td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              saldoParcialTablaAgrupado
                            )}
                        </td>
                      </tr>
                    );}
                  }
                })}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Anterior
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Cargos del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdoAgrupado)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Abonos del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {"-" + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdoAgrupado)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Bonificaciones del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {"-" + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalBonificacionesEdoAgrupado)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Devoluciones del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {"-" + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalDevolucionesEdoAgrupado)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Vencido
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoVencido)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Actual
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcialTablaAgrupado)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggleAgrupado}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xxl" isOpen={modalGlobal} toggle={toggleGlobal}>
        <ModalHeader toggle={toggleGlobal}>
          <h4>Estado de Cuenta de {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={2}>
              <ButtonGroup>
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFOCGlobal}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                {/* <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={toggleMail3}
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelFOCGlobal}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button> */}
              </ButtonGroup>
            </Col>

            <Col md={2}>
              <Row>
                <Col md={6}>
                  <Label className="mr-sm-2">Plazo {plazo} dias</Label>
                </Col>
              </Row>
            </Col>

            <Col md={3}>
              <Row>
                <Col md={3}>
                  <Label className="mr-sm-2">Fecha</Label>
                </Col>
                <Col md={6}>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    required
                    onChange={(e) => {
                      setSelectedFechaInicio(e.target.value);
                    }}
                  />
                </Col>
              </Row>
            </Col>

          

            <Col md={3}>
              <h4 align="right">
                Saldo{"  "}
                <Badge
                  id="Total"
                  color="danger"
                  className="BadgeSize badge-pill"
                >
                  {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldo)}
                </Badge>
              </h4>
            </Col>
          </Row>
          <div className="card container">
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr align="center">
                  <th className="tituloTabla" align="left">
                    Fecha
                  </th>
                  <th className="tituloTabla">Movimiento</th>
                  <th className="tituloTabla">Observaciones</th>
                  <th className="tituloTabla">Numero</th>
                  <th className="tituloTabla">Banco</th>
                  <th className="tituloTabla">Cargos</th>
                  <th className="tituloTabla">Abonos</th>
                  <th className="tituloTabla">Saldo</th>
                </tr>
              </thead>
              <tbody>
                {selectedFechaInicio ? (
                  <tr>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="right">Saldo Anterior</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">NA</td>
                    <td align="center">
                      {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial)}
                    </td>
                  </tr>
                ) : undefined}
                {movimientos.map((c) => {
                  if (
                    (selectedFechaInicio == "" ||
                      selectedFechaInicio <= c.fecha)
                  ) {
                    saldoParcialTablaGlobal = saldoParcialTablaGlobal + c.cargo - c.abono;
                    totalCargosEdoGlobal = totalCargosEdoGlobal + c.cargo;
                    totalAbonosEdoGlobal = totalAbonosEdoGlobal + c.abono;
                    totalSaldoEdoGlobal = totalCargosEdoGlobal - totalAbonosEdoGlobal;
                    let firstDate = new Date(c.fecha);
                    let diffDays = Math.round(Math.ceil((secondDate - firstDate) / oneDay))
                    if((c.movimiento == "Venta" || c.movimiento == "Nota Cargo") && c.saldo > 0 &&  diffDays > plazo){
                      saldoVencido = 0
                      saldoVencido = saldoVencido + c.saldo
                      return (
                        <tr style={{backgroundColor:"#ed8c8c"}}>
                          <td align="center">{c.fecha}</td>
                          <td align="center">{c.movimiento}</td>
                          <td align="center">{c.observaciones}</td>
                          <td align="center">{c.numero}</td>
                          <td align="center">{c.banco}</td>
                          <td align="right">
                            {c.cargo > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.cargo): ''}
                          </td>
                          <td align="right">
                            {c.abono > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.abono): ''}
                          </td>
                          <td align="right">
                            {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                                saldoParcialTablaGlobal
                              )}
                          </td>
                        </tr>
                      )
                    }else{
                    return (
                      <tr>
                        <td align="center">{c.fecha}</td>
                        <td align="center">{c.movimiento}</td>
                        <td align="center">{c.observaciones}</td>
                        <td align="center">{c.numero}</td>
                        <td align="center">{c.banco}</td>
                        <td align="right">
                          {c.cargo > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.cargo): ''}
                        </td>
                        <td align="right">
                          {c.abono > 0 ? new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(c.abono): ''}
                        </td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(
                              saldoParcialTablaGlobal
                            )}
                        </td>
                      </tr>
                    );}
                  }
                })}

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Anterior
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoInicial)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Cargos del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalCargosEdoGlobal)}
                  </td>
                </tr>

                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Abonos del Periodo
                  </td>
                  <td td className="negrita" align="right">
                    {"-" + new Intl.NumberFormat("en-US",{style: "currency", currency: "USD", maximumFractionDigits: 2}).format(totalAbonosEdoGlobal)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Vencido
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoVencido)}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td td className="negrita">
                    Saldo Actual
                  </td>
                  <td td className="negrita" align="right">
                    {new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(saldoParcialTabla)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={toggleGlobal}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {/* C12: Modal Estado de Cuenta por Surtido */}
      <Modal
        size="xxl"
        isOpen={modalPorSurtido}
        toggle={togglePorSurtido}
        style={{ maxWidth: "95%", margin: "0 auto" }}
        contentClassName="custom-modal-content"
      >
        <ModalHeader toggle={togglePorSurtido}>
          <h4>Estado de Cuenta por Surtido - {nombreCliente}</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={3}>
              <ButtonGroup>
                <Button size="sm" className="btn" color="danger" onClick={PDFOCPorSurtido}>
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
              </ButtonGroup>
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Plazo {plazo} dias</Label>
            </Col>
            <Col md={3}>
              <Row>
                <Col md={4}>
                  <Label className="mr-sm-2">Desde</Label>
                </Col>
                <Col md={6}>
                  <Input
                    bsSize="sm"
                    type="date"
                    value={selectedFechaInicio}
                    onChange={(e) => setSelectedFechaInicio(e.target.value)}
                  />
                </Col>
              </Row>
            </Col>
            <Col md={3}>
              <h4 align="right">
                Saldo{"  "}
                <Badge id="TotalPorSurtido" color="danger" className="BadgeSize badge-pill">
                  {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(saldo)}
                </Badge>
              </h4>
            </Col>
          </Row>
          <div className="card container">
            {gruposPorSurtido.length === 0 ? (
              <p style={{ padding: 12 }}>Sin surtidos.</p>
            ) : (
              gruposPorSurtido
                .filter((g) => !selectedFechaInicio || selectedFechaInicio <= g?.surtido?.fecha)
                .map((g, idx) => {
                  const s = g.surtido;
                  const movs = [...(g.movimientos || [])].sort((a, b) =>
                    a.fecha > b.fecha ? 1 : -1
                  );
                  let saldoRun = Number(s.total_general || 0);
                  return (
                    <div key={s._id || idx} style={{ marginBottom: 20 }}>
                      {/* D8: abonar / aplicar anticipo a este surtido */}
                      {Number(s.saldo) > 0.01 && (
                        <div style={{ marginBottom: 4 }}>
                          <Button
                            size="sm"
                            color="success"
                            title="Registrar un abono a esta nota"
                            onClick={() => abrirAbonoSurtido(s)}
                          >
                            <i className="fas fa-dollar-sign"></i> Abonar
                          </Button>{" "}
                          <Button
                            size="sm"
                            color="info"
                            title="Aplicar un anticipo del cliente a esta nota"
                            onClick={() => abrirAplicarAnticipoCte(s)}
                          >
                            <i className="fas fa-hand-holding-usd"></i> Aplicar anticipo
                          </Button>
                        </div>
                      )}
                      <Table
                        size="sm"
                        striped
                        borderless
                        className="table-responsive-xl"
                      >
                        <thead>
                          <tr
                            align="center"
                            style={s.vencido ? { backgroundColor: "#ed8c8c" } : undefined}
                          >
                            <th className="tituloTabla">Folio</th>
                            <th className="tituloTabla">Fecha</th>
                            <th className="tituloTabla">Movimiento</th>
                            <th className="tituloTabla">Observaciones</th>
                            <th className="tituloTabla">Banco/Factura</th>
                            <th className="tituloTabla">Cargos</th>
                            <th className="tituloTabla">Abonos</th>
                            <th className="tituloTabla">Bonificaciones</th>
                            <th className="tituloTabla">Devoluciones</th>
                            <th className="tituloTabla">Saldo</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            style={s.vencido ? { backgroundColor: "#ed8c8c" } : undefined}
                          >
                            <td align="center">
                              <b>{s.idSurtido}</b>
                            </td>
                            <td align="center">{s.fecha}</td>
                            <td align="center">
                              <b>Venta</b>
                            </td>
                            <td align="center">{s.observaciones}</td>
                            <td align="center">{s.noFactura || "NA"}</td>
                            <td align="right">
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(s.total_general)}
                            </td>
                            <td align="right"></td>
                            <td align="right"></td>
                            <td align="right"></td>
                            <td align="right">
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(saldoRun)}
                            </td>
                          </tr>
                          {movs.map((m, i) => {
                            const ab = Number(m.abono || 0);
                            const bo = Number(m.bonificacion || 0);
                            const dv = Number(m.devolucion || 0);
                            saldoRun = saldoRun - ab - bo - dv;
                            return (
                              <tr key={i}>
                                <td align="center">{m.numero || ""}</td>
                                <td align="center">{m.fecha}</td>
                                <td align="center">{m.movimiento}</td>
                                <td align="center">{m.observaciones}</td>
                                <td align="center">{m.banco || "NA"}</td>
                                <td></td>
                                <td align="right">
                                  {ab > 0
                                    ? new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 2,
                                      }).format(ab)
                                    : ""}
                                </td>
                                <td align="right">
                                  {bo > 0
                                    ? new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 2,
                                      }).format(bo)
                                    : ""}
                                </td>
                                <td align="right">
                                  {dv > 0
                                    ? new Intl.NumberFormat("en-US", {
                                        style: "currency",
                                        currency: "USD",
                                        maximumFractionDigits: 2,
                                      }).format(dv)
                                    : ""}
                                </td>
                                <td align="right">
                                  {new Intl.NumberFormat("en-US", {
                                    style: "currency",
                                    currency: "USD",
                                    maximumFractionDigits: 2,
                                  }).format(saldoRun)}
                                </td>
                              </tr>
                            );
                          })}
                          <tr>
                            <td colSpan={8}></td>
                            <td className="negrita" align="right">
                              Saldo Surtido{s.vencido ? ` (Vencido ${s.diasVencido}d)` : ""}
                            </td>
                            <td className="negrita" align="right">
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                                maximumFractionDigits: 2,
                              }).format(Number(s.saldo || 0))}
                            </td>
                          </tr>
                        </tbody>
                      </Table>
                    </div>
                  );
                })
            )}

            {/* Anticipos no aplicados */}
            {anticiposPorSurtido && anticiposPorSurtido.length > 0 && (
              <div style={{ marginTop: 10 }}>
                <h5 style={{ background: "#B02307", color: "#fff", padding: 6 }}>
                  Anticipos no aplicados
                </h5>
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <thead>
                    <tr align="center">
                      <th className="tituloTabla">Folio</th>
                      <th className="tituloTabla">Fecha</th>
                      <th className="tituloTabla">Banco</th>
                      <th className="tituloTabla">Observaciones</th>
                      <th className="tituloTabla">Importe</th>
                      <th className="tituloTabla">Saldo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {anticiposPorSurtido.map((a, i) => (
                      <tr key={a._id || i}>
                        <td align="center">{a.idAnticipo}</td>
                        <td align="center">{a.fecha}</td>
                        <td align="center">{a.banco || "NA"}</td>
                        <td align="center">{a.observaciones}</td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(Number(a.importe || 0))}
                        </td>
                        <td align="right">
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(Number(a.saldo || 0))}
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td colSpan={4}></td>
                      <td className="negrita" align="right">
                        Total Saldo Anticipos
                      </td>
                      <td className="negrita" align="right">
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(
                          anticiposPorSurtido.reduce(
                            (t, a) => t + Number(a.saldo || 0),
                            0
                          )
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            )}

            {/* Totales generales del cliente */}
            {gruposPorSurtido.length > 0 &&
              (() => {
                const totCargos = gruposPorSurtido.reduce(
                  (t, g) => t + Number(g?.surtido?.total_general || 0),
                  0
                );
                const totAbonos = gruposPorSurtido.reduce((t, g) => {
                  const movs = Array.isArray(g?.movimientos) ? g.movimientos : [];
                  return (
                    t +
                    movs.reduce(
                      (s, m) =>
                        s +
                        Number(m.abono || 0) +
                        Number(m.bonificacion || 0) +
                        Number(m.devolucion || 0),
                      0
                    )
                  );
                }, 0);
                const totSaldo = gruposPorSurtido.reduce(
                  (t, g) => t + Number(g?.surtido?.saldo || 0),
                  0
                );
                const totVencido = gruposPorSurtido.reduce(
                  (t, g) =>
                    t + (g?.surtido?.vencido ? Number(g?.surtido?.saldo || 0) : 0),
                  0
                );
                const fmt = (v) =>
                  new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(Number(v || 0));
                return (
                  <div style={{ marginTop: 16 }}>
                    <h5 style={{ background: "#B02307", color: "#fff", padding: 6 }}>
                      Totales generales del cliente
                    </h5>
                    <Table size="sm" borderless className="table-responsive-xl">
                      <tbody>
                        <tr>
                          <td className="negrita" align="right" style={{ width: "70%" }}>
                            Total Cargos
                          </td>
                          <td className="negrita" align="right">
                            {fmt(totCargos)}
                          </td>
                        </tr>
                        <tr>
                          <td className="negrita" align="right">
                            Total Abonos
                          </td>
                          <td className="negrita" align="right" style={{ color: "#f40903" }}>
                            {fmt(totAbonos)}
                          </td>
                        </tr>
                        <tr>
                          <td className="negrita" align="right">
                            Saldo Vencido
                          </td>
                          <td
                            className="negrita"
                            align="right"
                            style={{ color: "#f40903" }}
                          >
                            {fmt(totVencido)}
                          </td>
                        </tr>
                        <tr>
                          <td className="negrita" align="right">
                            Saldo General
                          </td>
                          <td className="negrita" align="right">
                            {fmt(totSaldo)}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                );
              })()}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={togglePorSurtido}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
        <ModalHeader toggle={toggleMail}>
          <h4>Enviar Estado de Cuenta</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={enviaMail}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal size="sm" isOpen={modalMail2} toggle={toggleMail2}>
        <ModalHeader toggle={toggleMail2}>
          <h4>Enviar Estado de Cuenta</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={emailFOC}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>
      <Modal size="sm" isOpen={modalMail3} toggle={toggleMail3}>
        <ModalHeader toggle={toggleMail3}>
          <h4>Enviar Estado de Cuenta</h4>
        </ModalHeader>
        <ModalBody>
          <Label className="mr-sm-2">Email</Label>
          <Input
            className="col-sm-12"
            type="text"
            value={mailTo}
            required
            onChange={(e) => {
              setMailTo(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button size="sm" color="success" onClick={emailFOCAgrupado}>
            Enviar
          </Button>
        </ModalFooter>
      </Modal>

      {/* D8: registrar un abono a la nota desde el estado de cuenta */}
      <Modal size="lg" isOpen={modalAbonoCte} toggle={() => setModalAbonoCte(!modalAbonoCte)}>
        <ModalHeader toggle={() => setModalAbonoCte(!modalAbonoCte)}>
          <h4>
            Abonar a Nota {surtidoSel?.idSurtido} — {nombreComercialCliente}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={4}>
              <Label>Saldo de la nota</Label>
              <Input
                disabled
                value={new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(surtidoSel?.saldo) || 0)}
              />
            </Col>
            <Col md={4}>
              <Label>Fecha</Label>
              <Input type="date" value={abFecha} onChange={(e) => setAbFecha(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Importe</Label>
              <Input
                type="number"
                min="0"
                step="any"
                value={abImporte}
                onChange={(e) => setAbImporte(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col md={4}>
              <Label>Banco</Label>
              <Input type="select" value={abBanco} onChange={(e) => setAbBanco(e.target.value)}>
                <option value="">Selecciona</option>
                {bancosCte
                  .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                  .map((b) => (
                    <option key={b._id} value={b._id}>
                      {b.banco} {b.cuenta}
                    </option>
                  ))}
              </Input>
            </Col>
            <Col md={4}>
              <Label>Forma de Pago</Label>
              <Input type="select" value={abFormaPago} onChange={(e) => setAbFormaPago(e.target.value)}>
                <option value="Transferencia">Transferencia</option>
                <option value="Efectivo">Efectivo</option>
                <option value="Cheque">Cheque</option>
                <option value="TDC">TDC</option>
              </Input>
            </Col>
            <Col md={4}>
              <Label>Observaciones</Label>
              <Input type="text" value={abObs} onChange={(e) => setAbObs(e.target.value)} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardarAbonoCte} disabled={guardandoCte}>
            {guardandoCte ? "Guardando..." : "Registrar abono"}
          </Button>
          <Button color="secondary" onClick={() => setModalAbonoCte(false)} disabled={guardandoCte}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* D8: aplicar un anticipo del cliente a la nota */}
      <Modal size="lg" isOpen={modalAplicarCte} toggle={() => setModalAplicarCte(!modalAplicarCte)}>
        <ModalHeader toggle={() => setModalAplicarCte(!modalAplicarCte)}>
          <h4>
            Aplicar anticipo a Nota {surtidoSel?.idSurtido} — {nombreComercialCliente}
          </h4>
        </ModalHeader>
        <ModalBody>
          {anticiposCte.length === 0 ? (
            <div style={{ padding: 12, backgroundColor: "#fff3cd", borderRadius: 4 }}>
              Este cliente no tiene anticipos con saldo disponible.
            </div>
          ) : (
            <>
              <Row>
                <Col md={4}>
                  <Label>Saldo de la nota</Label>
                  <Input
                    disabled
                    value={new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(Number(surtidoSel?.saldo) || 0)}
                  />
                </Col>
                <Col md={5}>
                  <Label>Anticipo</Label>
                  <Input
                    type="select"
                    value={anticipoCteSel}
                    onChange={(e) => {
                      const id = e.target.value;
                      setAnticipoCteSel(id);
                      const ant = anticiposCte.find((x) => x._id === id);
                      const sugerido = Math.min(
                        Number(ant?.saldo || 0),
                        Number(surtidoSel?.saldo || 0)
                      );
                      setAplicarImpCte(Number(sugerido.toFixed(2)));
                    }}
                  >
                    <option value="">Selecciona</option>
                    {anticiposCte.map((a) => (
                      <option key={a._id} value={a._id}>
                        #{a.idAnticipo} · {a.fecha} · disponible{" "}
                        {new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(a.saldo)}
                      </option>
                    ))}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Importe a aplicar</Label>
                  <Input
                    type="number"
                    min="0"
                    step="any"
                    value={aplicarImpCte}
                    onChange={(e) => setAplicarImpCte(e.target.value)}
                  />
                </Col>
              </Row>
              <br />
              <small style={{ color: "#6c757d" }}>
                Aplicar un anticipo no mueve el saldo del cliente ni ningún banco:
                el dinero ya entró cuando se registró el anticipo. Solo baja el saldo
                del anticipo y el de la nota.
              </small>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={guardarAplicarAnticipoCte}
            disabled={guardandoCte || anticiposCte.length === 0}
          >
            {guardandoCte ? "Aplicando..." : "Aplicar"}
          </Button>
          <Button color="secondary" onClick={() => setModalAplicarCte(false)} disabled={guardandoCte}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default EstadoCuenta;
